import { CSSProperties, MouseEvent, ReactNode } from 'react';
import { Card } from 'react-bootstrap';

interface Props {
  atributes?: {};
  classes?: string;
  children: ReactNode;
  footer?: ReactNode;
  styles?: CSSProperties;
  cardBodyClasses?: string;
  handleClick: (event: MouseEvent<HTMLDivElement>) => void;
}

export function ChooseCardContent({
  children,
  footer,
  atributes,
  classes,
  styles,
  cardBodyClasses,
  handleClick,
}: Props) {
  return (
    <div
      {...atributes}
      style={styles}
      className={`choose-card ${classes ?? ''}`}
      onClick={(e: MouseEvent<HTMLDivElement>) => handleClick(e)}
    >
      <div className={`py-2 ${cardBodyClasses ?? ''}`}>{children}</div>
      {footer && (
        <Card.Footer className="text-center">
          <small className="text-muted">{footer}</small>
        </Card.Footer>
      )}
    </div>
  );
}
